/**
 * 合并css module样式名
 * @param {Object} args 样式对象
 * @return {Object} 合并后的样式对象
 * @example
 */
export default (...args) => {
  let styles = {};
  for (let i = 0; i < args.length; i++) {
    Object.entries(args[i]).forEach(([key, value]) => {
      if (styles[key]) {
        styles[key] += ' ' + value;
      } else {
        styles[key] = value;
      }
    });
  }
  return styles;
};
